import styled from 'styled-components';

import { Breakpoint } from '../../../enums';
import { StyledComponent } from '../../../interfaces';
import { FormField } from '../../formField/formField.component';

import { StyledFormFieldProps } from './deliveryCompanyOrderForm.types';

export const FormikForm: StyledComponent<'form'> = styled.form`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  column-gap: 12px;
`;

export const StyledFormField: StyledComponent<typeof FormField, StyledFormFieldProps> = styled(FormField)<StyledFormFieldProps>`
  width: ${({ $fullWidth }: StyledFormFieldProps): string => $fullWidth ? '100%' : 'calc(50% - 6px)'};
  margin-top: 24px;

  @media ${Breakpoint.SmallMobile} {
    width: 100%;
  }
`;
